import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import {
  Answer,
  Question,
  QuestionInPage,
  QuestionnaireAnswer,
  QuestionType,
} from 'src/app/core/models/questionnaire.model';
import { QuestionContext } from '../question-multi-file/question-multi-file.component';
import { QuestionTooltipComponent } from '../question-tooltip/question-tooltip.component';

@Component({
  selector: 'app-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss'],
})
export class QuestionComponent implements OnInit, OnChanges {
  @Input('context') context!: QuestionContext;
  @Input() isHidden = false;
  @Input('question') question!: QuestionInPage;
  @Input('questionnaireAnswer') qa$!: Observable<QuestionnaireAnswer | null>;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  firstChange = true;
  firstAnswer: Answer | null = null;
  tooltipText = '';
  tooltipConfig: any = null;

  constructor(private dialog: MatDialog) { }

  ngOnInit(): void {
    this.firstAnswer = this.question?.cp_question?.answer || null;
    this.computeTooltipText();

    if (this.question.cp_question.response_type == QuestionType.TABLE) {
      console.log('this.question', this.question);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['question']) {
      this.computeTooltipText();
    }
  }

  private computeTooltipText() {
    const tooltip = this.question?.cp_question?.configuration?.tooltip;
    this.tooltipConfig = tooltip || null;
    if (!tooltip) {
      this.tooltipText = '';
      return;
    }

    const lines: string[] = [];

    if (tooltip.user?.text) {
      lines.push(tooltip.user.text);
    }

    lines.push('');
    lines.push('Click to watch the video!');

    this.tooltipText = lines.join('\n');
  }

  change(ev: QuestionAnswer) {
    console.log('CAIO7 - change', {
      ev,
      firstChange: this.firstChange,
      firstAnswer: this.firstAnswer,
    });

    if (this.firstChange && ev.answer.value === this.firstAnswer?.value) {
      this.firstChange = false;
      return;
    }

    this.changeAnswer.next(ev);
  }

  showTooltip() {
    const tooltip = this.tooltipConfig || this.question.cp_question.configuration?.tooltip;
    if (!tooltip) return;

    const userTip = tooltip.user;
    if (!userTip) return;

    this.dialog.open(QuestionTooltipComponent, {
      data: { text: userTip.text || '', youtube_video: userTip.youtube_video || null },
      width: '90vw',
      maxWidth: '760px',
      panelClass: 'question-tooltip-panel',
    });
  }
}

export interface QuestionAnswer {
  question: Question;
  answer: Answer;
}
